import { toLocaleDecimal } from "../../Common/helpers/toLocaleDecimal";

export function getCallSentimentValue(sentiment: number) {
  const value = sentiment * 10;
  const decimal = toLocaleDecimal(value);

  return sentiment > 0 ? `+${decimal}` : decimal;
}
